export const OPPORTUNITY_AVERAGE_COST = 600;

// Expected opportunity values are 60% to 160% of the average cost / earning projection
export const OPPORTUNITY_LOW_END_EXPECTED_FEE_ADJUSTMENT = 0.6;
export const OPPORTUNITY_HIGH_END_EXPECTED_FEE_ADJUSTMENT = 1.6;
export const OPPORTUNITY_LOW_END_EXPECTED_EARNINGS_ADJUSTMENT = 1.6;
export const OPPORTUNITY_HIGH_END_EXPECTED_EARNINGS_ADJUSTMENT = 2.6;
